import React from 'react';
import { string, number, bool } from 'prop-types';
import FilterCollapsePanel from '../FilterCollapsePanel/FilterCollapsePanel';
import OLDCommonRangeFilter from './OLDCommonRangeFilter/OLDCommonRangeFilter';

function OLDRangeFilter({
    className,
    label,
    min,
    max,
    attribute,
    openedByDefault,
    ...otherProps
}) {
    return (
        <FilterCollapsePanel
            label={label}
            className={className}
            dataQa={attribute}
            openedByDefault={openedByDefault}
        >
            <OLDCommonRangeFilter
                min={min === null ? undefined : min}
                max={max === null ? undefined : max}
                attribute={attribute}
                {...otherProps}
            />
        </FilterCollapsePanel>
    );
}

OLDRangeFilter.propTypes = {
    className: string,
    label: string.isRequired,
    min: number,
    max: number,
    attribute: string.isRequired,
    openedByDefault: bool,
};

OLDRangeFilter.defaultProps = {
    className: null,
    min: null,
    max: null,
    openedByDefault: true,
};

export default OLDRangeFilter;
